import { useState } from 'react';

import { LocationType, StyledLogo } from 'src/templates/UnauthenticatedTemplate';

import { useHistory, useLocation } from 'react-router-dom';
import samsonLogoLarge from 'src/assets/logo-default.svg';
import { useTenant } from 'src/providers/Tenant';
import { useUser } from 'src/providers/User';

import { useTranslation } from 'react-i18next';
import { Feature } from 'src/Feature';
import { LoadingSpinner } from '../Loading';
import { LoginForm } from './LoginForm';
import SSOLoginButton from './SSOLoginButton';
import { CreateAccountButton, RegisterTitle, StyledDivider, StyledFormContainer } from './styles';

/* istanbul ignore next */
function LoginFormContainer() {
  const [loading, setLoading] = useState(false);
  const { logoUrl, identityProviders, accountId } = useTenant();
  const { login } = useUser();

  const history = useHistory();
  const location = useLocation<LocationType>();
  const { t } = useTranslation('authentication');

  const switchPage = /* istanbul ignore next */ () => {
    history.push('/send-reset-password-email');
  };

  return (
    <StyledFormContainer>
      {loading ? (
        /* istanbul ignore next */
        <LoadingSpinner width="320" />
      ) : (
        <StyledLogo src={logoUrl ?? samsonLogoLarge} alt={`${accountId} logo`} />
      )}
      <LoginForm switchPage={switchPage} setLoading={setLoading} login={login} history={history} location={location} />
      <Feature flag="self-registration">
        <>
          <StyledDivider />
          <div>
            <RegisterTitle>{t('register.dontHaveAnAccount')}</RegisterTitle>
            <CreateAccountButton to="/create-account">{t('register.createAnAccount')}</CreateAccountButton>
          </div>
        </>
      </Feature>
      {identityProviders?.length ? (
        /* istanbul ignore next */
        <>
          <RegisterTitle>{t('alternativeLogin')}</RegisterTitle>
          {identityProviders.map(
            /* istanbul ignore next */ ({ id, displayName }) => (
              <SSOLoginButton key={id} id={id} displayName={displayName} />
            )
          )}
        </>
      ) : null}
    </StyledFormContainer>
  );
}

export default LoginFormContainer;
